<app-core></app-core>